import { useMutation, useQueryClient } from "@tanstack/react-query";
import { requestCategoryService } from "../services/requestCategory.service";
import { UpdateRequestPayload } from "../types/research.types";

import { toast } from "sonner";

export const useUpdateRequest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UpdateRequestPayload) => requestCategoryService.updateRequest(payload),
    onSuccess: () => {
      // Invalidate requests query to refetch the updated list
      queryClient.invalidateQueries({ queryKey: ["requests"] });
      toast.success("Request Updated", {
        description: "Request updated successfully",
      });
    },
    onError: (error) => {
      console.error("Failed to update request:", error);
      toast.error("Update Failed", {
        description: "Failed to update request. Please try again.",
      });
    },
  });
};
